import React from 'react'
import styled from 'styled-components'
import Avatar from 'components/display/Avatar'
import LazyImage from 'components/display/LazyImage'
import { ParagraphSm } from 'components/display/Typography'
import TextWithLineBreaks from 'components/TextWithLineBreaks'

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 24px 0;

  ${Avatar} {
    height: 100px;
    width: 100px;
  }
`

const Card = styled.div`
  border: 1px solid #dddddd;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
`

type MessageProps = {
  referral: GQL_GetCustomerReferralQuery['customerReferral']
}

const Message = ({ referral }: MessageProps) => {
  const { referrer } = referral

  return (
    <Wrapper>
      <Avatar>
        <LazyImage data-src={referrer.avatar.thumbLg} />
      </Avatar>
      <Card>
        <ParagraphSm>
          <TextWithLineBreaks text={referral.message} />
        </ParagraphSm>
      </Card>
    </Wrapper>
  )
}

export default Message
